import Reveal from "../Reveal";

export const CrewCard = ({ item, index, slug }) => (
  <Reveal
    delay={index * 80}
    className="card-flat p-5 md:p-8 flex flex-col justify-between min-h-[160px] md:min-h-[180px]"
    data-testid={`crew-${slug}`}
  >
    <div className="font-display text-5xl md:text-7xl tracking-tightest text-ink-900 leading-none">
      {item.count}
    </div>
    <div className="mt-5 md:mt-6">
      <div className="overline">{item.role}</div>
      <p className="mt-2 md:mt-3 text-[12px] md:text-[13px] text-ink-500 leading-relaxed">
        {item.desc}
      </p>
    </div>
  </Reveal>
);
